/* ============================================================
   El Kit Definitivo — PDP controller (Phase 1 mockup)
   Becomes assets/custom-kit-pdp.js. The name-injection block
   is the spec's "name linking" logic, with the mockup-only
   fallback to a sample name instead of redirecting to the quiz.
   ============================================================ */
(function(){
  'use strict';

  /* ---- HOT SALE banner — rotating slider ---- */
  (function(){
    var msgs = document.querySelectorAll('#kp-hotsale .kp-hotsale-msg');
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function(){
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, 3000);
  })();

  /* ---- 4.1 / 4.12 Cap counter — same logic as the quiz (quiz-kit) ----
     Shares localStorage 'kitCapState' + sessionStorage 'kitCapSession'
     with the quiz, so the number flows continuously quiz -> PDP. */
  (function(){
    var nodes = document.querySelectorAll('[data-kits-remaining]');
    if (!nodes.length) return;
    var bar = document.getElementById('kp-cap');

    var CAP_BASE    = 487;   // quiz CAP_BASE
    var CAP_MIN     = 19;    // never deplete past this
    var CAP_VERSION = '1';   // bump to reset every visitor's stored counter
    var KEY = 'kitCapState';

    var value = CAP_BASE;
    try{
      var raw = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (raw && raw.v === CAP_VERSION && typeof raw.n === 'number'){
        value = raw.n;
        /* New session => the count is 100 units lower than last visit */
        if (!sessionStorage.getItem('kitCapSession')){ value -= 100; }
      }
    }catch(e){}
    if (value < CAP_MIN){ value = CAP_MIN; }
    try{ sessionStorage.setItem('kitCapSession', '1'); }catch(e){}

    function persist(n){
      try{ localStorage.setItem(KEY, JSON.stringify({ v:CAP_VERSION, n:n })); }catch(e){}
    }
    function render(n){
      nodes.forEach(function(el){ el.textContent = n; });
      if (bar){ bar.classList.toggle('is-low', n < 100); }
    }

    render(value);
    persist(value);

    /* While on the page: drop 1-3 every 3s / 5s / 4s (cycling) */
    var gaps = [3000, 5000, 4000], gi = 0;
    function tickDown(){
      if (value > CAP_MIN){
        var drop = 1 + Math.floor(Math.random() * 3);
        value = Math.max(CAP_MIN, value - drop);
        render(value);
        persist(value);
      }
      gi = (gi + 1) % gaps.length;
      setTimeout(tickDown, gaps[gi]);
    }
    setTimeout(tickDown, gaps[0]);
  })();

  /* ---- 5. NAME INJECTION — the link between quiz and PDP ----
     Gate removed: with no/invalid ?name= the page still loads,
     showing the non-personalized title + neutral wording (no redirect). */
  (function(){
    var params = new URLSearchParams(window.location.search);
    var name = params.get('name');

    /* Fallback to sessionStorage (back button / checkout return).
       Quiz writes `kitCustomerName`; we also read `alfavita_customer_name`. */
    if (!name){
      try{
        name = sessionStorage.getItem('alfavita_customer_name')
            || sessionStorage.getItem('kitCustomerName');
      }catch(e){}
    }

    /* No/invalid name -> show the page non-personalized, do NOT redirect */
    if (!name || !/^[a-zA-ZÀ-ÿ\s]{1,20}$/.test(name)){
      var h1 = document.querySelector('[data-product-title]');
      if (h1) h1.textContent = 'El Kit Definitivo Para Acelerar Tu Crecimiento Capilar';
      var gp = document.querySelector('.kp-guar-body p:last-child');
      if (gp) gp.textContent = 'Eso es cuánto creemos en lo que pusimos en tu kit.';
      var fh = document.querySelector('.kp-final .kp-h2');
      if (fh) fh.textContent = 'Tu kit está listo para armarse.';
      var fb = document.querySelector('.kp-final .product-cta');
      if (fb) fb.textContent = 'Reservar mi Kit';
      document.title = 'El Kit Definitivo Para Acelerar Tu Crecimiento Capilar | Alfavita';
      return;
    }

    /* Format: First-letter caps, trimmed */
    var formatted = name.trim().split(/\s+/).map(function(w){
      return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    }).join(' ');

    /* Inject into every [data-customer-name] placeholder */
    document.querySelectorAll('[data-customer-name]').forEach(function(el){
      el.textContent = formatted;
    });

    document.title = 'El Kit Definitivo de ' + formatted + ' | Alfavita';

    try{
      sessionStorage.setItem('alfavita_customer_name', formatted);
      sessionStorage.setItem('kitCustomerName', formatted);
    }catch(e){}

    /* 6. Cart line-item property -> name flows to the order + label */
    var prop = document.querySelector('input[name="properties[Nombre en el kit]"]');
    if (prop) prop.value = formatted;
  })();

  /* ---- 4.2 Gallery thumbnails + tap-to-zoom ---- */
  (function(){
    var main = document.getElementById('kp-gimg');
    var thumbs = document.querySelectorAll('#kp-thumbs .kp-thumb');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        thumbs.forEach(function(x){ x.classList.remove('is-on'); });
        t.classList.add('is-on');
        if (main && t.dataset.full) main.src = t.dataset.full;
      });
    });
    var lb = document.getElementById('kp-lightbox');
    var lbImg = document.getElementById('kp-lightbox-img');
    var gmain = document.getElementById('kp-gmain');
    if (gmain) gmain.addEventListener('click', function(){
      lbImg.src = main.src; lb.classList.add('is-on');
    });
    document.getElementById('kp-lightbox-x').addEventListener('click', function(){
      lb.classList.remove('is-on');
    });
    lb.addEventListener('click', function(e){
      if (e.target === lb) lb.classList.remove('is-on');
    });
  })();

  /* ---- 4.3 Before/After slider ---- */
  (function(){
    var frame  = document.getElementById('kp-ba');
    var after  = document.getElementById('kp-ba-after');
    var handle = document.getElementById('kp-ba-handle');
    if (!frame || !after || !handle) return;
    var dragging = false;

    function setPos(clientX){
      var r = frame.getBoundingClientRect();
      var pct = (clientX - r.left) / r.width * 100;
      pct = Math.max(2, Math.min(98, pct));
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
    }
    function down(e){ dragging = true; move(e); }
    function up(){ dragging = false; }
    function move(e){
      if (!dragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPos(x);
    }
    handle.addEventListener('mousedown', down);
    frame.addEventListener('mousedown', down);
    window.addEventListener('mouseup', up);
    window.addEventListener('mousemove', move);
    handle.addEventListener('touchstart', down, {passive:true});
    frame.addEventListener('touchstart', down, {passive:true});
    window.addEventListener('touchend', up);
    window.addEventListener('touchmove', move, {passive:true});
  })();

  /* ---- 4.3 Review carousel ---- */
  (function(){
    var track = document.getElementById('kp-revtrack');
    if (!track) return;
    function step(dir){
      var card = track.querySelector('.kp-rev');
      var w = card ? card.offsetWidth + 16 : track.offsetWidth;
      track.scrollBy({ left: dir * w, behavior:'smooth' });
    }
    document.getElementById('kp-rev-prev').addEventListener('click', function(){ step(-1); });
    document.getElementById('kp-rev-next').addEventListener('click', function(){ step(1); });
  })();

  /* ---- 4.11 FAQ accordion ---- */
  (function(){
    document.querySelectorAll('#kp-faq .kp-faq-q').forEach(function(q){
      q.addEventListener('click', function(){
        q.parentNode.classList.toggle('is-open');
      });
    });
  })();

  /* ---- 4.3 Review cards slider (same as alfavita2 section 5) ---- */
  (function(){
    var track  = document.getElementById('av2-rcards-track');
    var slider = document.getElementById('av2-rcards-slider');
    if (!track || !slider) return;
    var dots   = document.querySelectorAll('.av2-rcard-dot');
    var cards  = document.querySelectorAll('.av2-rcard');
    var total  = cards.length;
    var current = 0;
    function goTo(idx){
      current = ((idx % total) + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function(d,i){ d.classList.toggle('active', i === current); });
    }
    document.getElementById('av2-rcards-prev').addEventListener('click', function(){ goTo(current - 1); });
    document.getElementById('av2-rcards-next').addEventListener('click', function(){ goTo(current + 1); });
    dots.forEach(function(d){
      d.addEventListener('click', function(){ goTo(parseInt(d.dataset.idx)); });
    });
    var startX = 0;
    slider.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; }, {passive:true});
    slider.addEventListener('touchend', function(e){
      var diff = startX - e.changedTouches[0].clientX;
      if(Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
    }, {passive:true});
  })();

  /* CTA buttons -> add the kit to cart, then go to checkout.
     Variant 59544009375825 = product 15818167648337 (Kit Definitivo). */
  (function(){
    var VARIANT = 59544009375825;
    var btns = document.querySelectorAll('.product-cta, #kp-sticky-cta');
    if (!btns.length) return;

    function addToCart(btn){
      var orig = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Agregando...';
      var nameProp = document.querySelector('input[name="properties[Nombre en el kit]"]');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{
          id: VARIANT,
          quantity: 1,
          properties: { 'Nombre en el kit': (nameProp && nameProp.value) || '' }
        }] })
      }).then(function(r){
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      }).catch(function(){
        btn.disabled = false;
        btn.textContent = orig;
        window.location.href = '/products/kit-ultimate-booster-crecimiento-capilar-hotsale';
      });
    }

    btns.forEach(function(b){
      b.addEventListener('click', function(){ addToCart(b); });
    });
  })();

})();
